export type EnTranslationsType = typeof enTranslations;

export const enTranslations = {
  translation: {
    actions: 'Actions',
    activate: 'Activate',
    active: 'Active',
    activity: 'Activity',
    allSchoolClasses: 'All classes of the school',
    allSchoolGroups: 'All groups of the school',
    allSchoolStudents: 'All students of the school',
    analysisBoard: 'Analysis board',
    answer: 'Answer',
    assign: 'Assign',
    assignment: 'Test',
    assignments: 'Tests',
    assignmentsPage: {
      addAssignment: 'Creating a test',
      assignmentConsistOf: 'Test work consists of',
      callToActionCreate: 'Create a test',
      checkpointMessage: 'This is a certification work. Good luck!',
      chooseClass: 'Choose a class and we will suggest you appropriate tasks',
      chooseGroup: 'Choose a group and we will suggest you appropriate tasks',
      chooseTopics: 'Choose topics',
      createAssignment: 'Create an assignment',
      createdList: 'This page will display all the assignments you create.',
      deadlines: 'Specify deadlines',
      editAssignment: 'Edit test',
      noAssignment: "There's no test work here yet",
      noTopics: 'No topics found for this class',
      noTopicsForClass: 'No topics found for this class',
      noTopicsForGroup: 'No topics found for this group',
      quarter: 'for a quarter',
      taskHasFinished: 'Task completed',
      taskNotStarted: "The task hasn't started",
    },
    attempt: 'Attempt',
    attempts: 'Attempts',
    attention: 'Attention!',
    auth: {
      auth: 'Authorization',
      changeEmail: 'Change email',
      changePassword: 'Change password',
      checkEmail: 'Check your email!',
      confirmPassword: 'Confirm Password',
      email: 'Email',
      enter: 'Login',
      enterEmail: 'Enter your email address',
      enterNewPassword: 'Enter a new password',
      errorOldPassword: 'The new password must be different from the old one',
      finishRegister: 'Complete registration',
      forgotPassword: 'Forgot your password?',
      incorrectLogin: 'Incorrect login or password',
      inviteSchoolAccepted: 'You have accepted an invitation to a new school!',
      inviteWrongCode: 'The invitation or its validity period is invalid',
      login: 'Login',
      newPassword: 'New Password',
      password: 'Password',
      passwordMinLength: 'At least 6 symbols',
      pleaseCheckEmail: 'Please, check your email',
      recoverPassword: 'Password recovery',
      resetPassword: 'Reset password',
      resetPasswordHelpMessage: 'Or you can ask the Teacher to reset your password.',
      resetPasswordMessage: 'Enter your email address to reset your password',
      schoolNotActive: 'The school is not activated',
      schoolNotActiveCoach:
        'Your school does not have access to the Chess Class system, please contact your school coordinator',
      schoolNotActiveStudent:
        'Your school does not have access to the Chess Class system, please contact your teacher',
      schoolNotActiveSuperCoach:
        'Your school does not have access to the Chess Class system, please contact the support team {{supportEmail}}',
      send: 'Send',
      sendConfirmation:
        'We have sent you an email with instructions on how to reset your password.',
      updatePassword: 'Update password',
      userInactive: 'The user with this email address has been blocked',
      userNotActive: 'User not activated',
      welcome: 'Welcome',
      welcomeToChess: 'Welcome to Chess Class!',
    },
    author: 'Author',
    authors: 'Authors',
    back: 'Back',
    birthDate: 'Date of Birth',
    boardEditorPage: {
      black: 'Black',
      blacksMove: "Black's move",
      boardEditor: 'Board editor',
      castling: 'Castling',
      clearTheBoard: 'Clear the board',
      nextMove: 'Next move',
      startingPosition: 'Starting position',
      turnTheBoardOver: 'Turn the board over',
      white: 'White',
      whitesMove: "White's move",
    },
    cancel: 'Cancel',
    cartoon: 'Cartoon',
    chapter: 'Topic',
    chapter_few: 'Topics',
    chapter_many: 'Topics',
    chapter_other: 'Topics',
    chapters: 'Topics',
    chaptersPage: {
      chapterList: 'Topics list',
      recommendationForCoach: 'Recommendation for teacher',
    },
    choose: 'Choose',
    chooseLanguage: 'Choose language',
    class: 'Class',
    classStudio: 'Class studio',
    classWork: 'Work in class',
    classes: 'Classes',
    classesPage: {
      activateStudentMessage:
        'Are you sure you want to give access to the system for the student {{fullName}}',
      addClass: 'Add class',
      addGroup: 'Add group',
      addStudent: 'Add student',
      assignClass: 'Assign class',
      assignGroup: 'Assign group',
      backToClasses: 'Back to classes',
      backToGroups: 'Back to groups',
      classLetter: 'Class letter',
      classNumber: 'Class number',
      createClass: 'Create class',
      createGroup: 'Create group',
      deactivateStudentMessage:
        'Are you sure you want to suspend access to the system for student {{fullName}}?',
      deleteClassMessage: 'Are you sure you want to remove “Class {{grade}} {{symbol}}”?',
      deleteGroupMessage: 'Are you sure you want to remove “Group {{symbol}}”?',
      editClass: 'Edit class',
      editCoach: 'Edit teacher',
      editGroup: 'Edit group',
      editStudent: 'Edit student',
      editTeacher: 'Edit teacher',
      educationLanguage: 'Education language',
      excludeFromClass: 'Delete from class',
      excludeFromGroup: 'Delete from group',
      excludeFromSchool: 'Delete from school',
      excludeStudentFromClass: 'Are you sure you want to delete {{fullName}} from the class?',
      excludeStudentFromGroup: 'Are you sure you want to delete {{fullName}} from the group?',
      excludeStudentFromSchool: 'Are you sure you want to delete {{fullName}} from the school',
      exportPdf: 'Export PDF',
      groupNumber: 'Group number',
      loginGenerate: 'Login is generated by the Email field',
      myClasses: 'My classes',
      myGroups: 'My groups',
      myStudents: 'My students',
      noGrades: 'No grades are posted',
      noHomework: 'There is no homework',
      noIndependentWork: 'There are no independent assignments',
      noStudents: 'There are no students',
      resetPassword: 'Reset password',
      studentPasswordGenerate: 'Student password generated by the field "Date of Birth"',
      studentsCount: 'Number of students',
      successActivateStudentMessage: 'Student successfully activated',
      successDeactivateStudentMessage: 'Student successfully deactivated',
      successExcludeStudentFromClassMessage: 'Student successfully removed from class',
      successExcludeStudentFromGroupMessage: 'Student successfully removed from group',
      successExcludeStudentFromSchoolMessage: 'Student successfully removed from school',
      tableEmptyPlaceholder: 'Students will appear here after they join your school',
      unassigned: 'Unassigned',
    },
    clear: 'Clear',
    coach: 'Teacher',
    coaches: 'Teachers',
    content: 'Content',
    copied: 'Copied',
    copy: 'Copy',
    correctLessonsCount: 'tasks correctly',
    create: 'Create',
    date: 'Date',
    delete: 'Delete',
    edit: 'Edit',
    email: 'Email',
    executionReport: 'Execution report',
    exercise: 'Exercise',
    exerciseStatus: {
      FAILED: 'Incorrect',
      HOORAYGOODANSWER: "Yay! That's the right answer!",
      NA: 'Not achieved',
      SOLVED: 'Resolved',
    },
    exercises: 'Exercises',
    exit: 'Exit',
    filter: 'Filter',
    finish: 'Finish',
    finishAt: 'Finish at',
    finishDate: 'Date of completion',
    fio: 'Fullname',
    firstName: 'Name',
    gender: {
      boy: 'Boy',
      female: 'Female',
      girl: 'Girl',
      male: 'Male',
      title: 'Gender',
    },
    givenDate: 'Issued',
    goBack: 'Go back',
    grade: 'Grade',
    grades: 'Grades',
    group: 'Group',
    groupStudio: 'Group studio',
    groups: 'Groups',
    guideline: 'Guideline',
    guidelines: 'Guidelines',
    help: 'Help',
    helpModal: {
      haveQuestions: 'Any questions?',
      helpText: 'In case of questions you can contact us by email',
    },
    hide: 'Hide',
    homeWorkIsDone: 'Homework completed',
    homework: 'Homework',
    homeworks: 'Homeworks',
    homeworksPage: {
      addHomework: 'Creation of homework',
      attempts: 'Attempts',
      callToActionCreate: 'Create homework',
      chooseClass: 'Choose a class and we will suggest you appropriate topics',
      chooseGroup: 'Choose a group and we will suggest you appropriate topics',
      chooseTopic: 'Choose topic',
      completed: 'Completed',
      correctTasksCount: '{{count}} / {{total}} tasks correctly',
      createHomework: 'Create a task',
      createdList: 'This page will display all the homeworks you create',
      currentDeadLine: 'Current deadline',
      deadlines: 'Specify deadlines',
      deadlinesEdit: 'Edit due dates',
      deleteHomeworkMessage: 'Are you sure you want to delete “{{name}}”?',
      editDueDate: 'Edit deadlines',
      execute: 'Start',
      homework: 'Homeworks',
      homeworkConsistOf: 'Homework consists of',
      issued: 'Issued',
      newDeadLine: 'New deadline',
      noTopics: 'No topics found for this class',
      noTopicsForClass: 'No topics found for this class',
      noTopicsForGroup: 'No topics found for this group',
      possible: '/ {{count}} possible',
      startHomeworkMessage: 'Do you really want to get started on your homework?',
      startIndependentMessage: 'Do you really want to get started on your independent work?',
      successEditDueDateChange: 'Deadline(s) changed successfully',
      task: 'Task',
      tasks: 'Tasks',
      toAllStudents: 'To all students',
      usedAttemptsCount: 'Number of used attempts',
      watchChapter: 'View topic',
    },
    iin: 'IIN',
    independentWork: 'Independent work',
    independentWorks: 'Independent works',
    invalidEmail: 'Invalid email',
    language: {
      de: 'German',
      en: 'English',
      fr: 'French',
      kz: 'Kazakh',
      ru: 'Russian',
    },
    lastName: 'Last Name',
    lesson: 'Lesson',
    lessons: 'Lessons',
    lessonsPage: {
      firstLevel: '1st level',
      fourthLevel: '4th level',
      secondLevel: '2nd level',
      thirdLevel: '3rd level',
      topicsMessage: 'This is where you can see the lesson topics you have completed',
      welcomeToChess: 'Hello! Welcome <br />to Chess <span class="text-primary">Class</span>',
    },
    login: 'Login',
    materials: 'Additional materials',
    messages: {
      birthDateShouldNotBeInTheFuture: 'Birth date should not be in the future',
      chapterNotSelected: 'Chapter is not selected',
      dueDateCannotBeEarlierThanStartDate: 'The due date cannot be earlier than the start date',
      dueDateCannotBeEarlierThanTheCurrentDate:
        'The due date cannot be earlier than the current date',
      error: 'There was an error, try again',
      errorEmailAlreadyUsed: 'The mail address is already in use',
      errorPostReview: 'Failed to save review',
      errorProfileNotFound: 'Profile not found',
      errorReviewPost: 'Failed to save review',
      errorUserNotFound: 'User not found',
      studentNotSelected: 'Student is not selected',
      successAdminInvite: 'Invitation to staff has been sent',
      successAssignmentCreate: 'The test been successfully created',
      successAssignmentDelete: 'The test has been successfully deleted!',
      successAssignmentEdit: 'The test has been successfully modified',
      successAuthorDelete: 'The author successfully removed!',
      successAuthorEdit: 'The author successfully modified',
      successChapterCreate: 'The topic successfully created',
      successChapterDelete: 'The topic successfully deleted!',
      successChapterEdit: 'The topic successfully modified',
      successChapterGive: 'Subject successfully issued',
      successClassCreate: 'The class successfully created',
      successClassDelete: 'The class successfully  deleted!',
      successClassEdit: 'The class successfully modified',
      successCoachDelete: 'Teacher successfully removed!',
      successCoachEdit: 'Teacher successfully modified',
      successExerciseDelete: 'The task successfully deleted!',
      successExerciseGroupDelete: 'Exercise group deleted',
      successExerciseGroupEdit: 'The exercise group modified',
      successGroupCreate: 'The group successfully created',
      successGroupDelete: 'The group successfully deleted!',
      successGroupEdit: 'The group successfully modified',
      successHomeworkCreate: 'Homework successfully created',
      successHomeworkDelete: 'Homework successfully deleted!',
      successPasswordInvoke: 'A password reset email has been sent to your mailbox',
      successPasswordUpdate: 'Password successfully updated',
      successProfileEdit: 'Profile successfully updated',
      successRegister: 'Successful registration',
      successReviewPost: 'Review successfully saved',
      successSchoolDelete: 'The school successfully deleted',
      successStaffDelete: 'Staff successfully deleted',
      successStaffEdit: 'Staff successfully modified',
      successStudentAdd: 'The student has been successfully added to the class',
      successStudentAddToClass: 'The student successfully added to the class',
      successStudentAddToGroup: 'The student successfully added to the group',
      successStudentCreate: 'The student successfully created',
      successStudentEdit: 'The student successfully modified',
      successVideoDelete: 'The video successfully deleted',
      successVideoEdit: 'The video successfully modified',
      successVideoFileDelete: 'Video file successfully deleted',
      successVideoFileEdit: 'Video file successfully modified',
      successVideoFileUpload:
        'The video file has been successfully uploaded, after a while it will be available for selection',
      warningAssignmentConsistOf: 'The test must contain at least one task',
      warningHomeworkConsistOf: 'Homework must contain at least one task/test',
      warningSession: 'Expired or wrong format try again later',
      warningStudentEmail: 'A student with this email address has already been registered',
    },
    middleName: 'Patronymic',
    modals: {
      exerciseAttemptsTooltipDescription:
        'The total number of attempts can be used for a single task or distributed among several tasks as you see fit. Use attempts wisely to maximize the efficiency of each task.',
      exerciseAttemptsTooltipTitle: 'You are given attempts to solve problems.',
      exerciseHelpText:
        'Most of the attempts have been used. Try moving on to other tasks to improve your score and increase your chances of success.',
      goodLuck: 'Good luck!',
      incorrectAnswer: 'Incorrect',
      mustAnswerAllQuestions: 'All questions must be answered!',
      tryAgain: 'Try again',
    },
    more: 'More',
    newestFirst: 'Newest first',
    next: 'Next',
    no: 'No',
    noResult: 'No results',
    notFoundResult: {
      chooseClass: 'Choose a class',
      chooseGroup: 'Choose a group',
      createClass: 'Create a class',
      createClassHelpMessage: 'You can create a new class in the classes tab',
      createGroup: 'Create a group',
      createGroupHelpMessage: 'You can create a new group in the groups tab',
      goBackToAssignments: 'Go back to the All Controlled Assignments tab',
      goBackToHomeworks: 'Go back to the all homework tab',
      noAssignment: 'Test not found',
      noChapterExercises: 'Tasks are not added to this topic',
      noChapters: 'Topics not found',
      noCoach: 'No coach was found',
      noHomework: 'Homework not found',
      noHomeworkExercises: 'Tasks in the homework were not found',
      noLessons: 'Lessons not found',
      noMaterials: 'No additional material has been added to this topic',
      noStudent: 'Student not found',
    },
    oldestFirst: 'Oldest first',
    passed: 'Passed',
    pause: 'Pause',
    phone: 'Phone',
    phoneNumber: 'Phone number',
    problem: 'Task',
    problem_few: 'Tasks',
    problem_many: 'Tasks',
    problem_other: 'Tasks',
    problems: 'Tasks',
    proceed: 'Start',
    profile: 'Profile',
    profilePage: {
      birthDate: 'Date of birth',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      firstName: 'Name',
      gender: 'Gender',
      genderPlaceholder: 'Choose a gender',
      iin: 'IIN',
      lastName: 'Last name',
      loginAndPassword: 'Login and password',
      loginHelpText: 'Login is generated by the "email" field',
      middleName: 'Patronymic',
      passwordRepeatError: 'This password has already been used before, please create a new one',
      personalInfo: 'Personal Information',
      phone: 'Phone',
      phonePlaceholder: 'Enter you phone number',
      profileSettings: 'Profile settings',
      schoolAndCoach: 'School and coach',
      schoolAndTeacher: 'School and teacher',
      withoutCoach: 'No teacher',
      withoutCoachHelpText: 'You are not connected to any teacher',
      withoutTeacher: 'Without a teacher',
      withoutTeacherHelpText: 'You are not connected to any teacher',
    },
    profileSettings: 'Profile settings',
    report: 'Report',
    requiredField: 'This field is required',
    result: 'Result',
    results: 'Results',
    review: {
      review: 'Review',
      reviewChapter: 'Please rate this topic',
      reviewContent: 'Please review our content',
      reviewLesson: 'Please review this chapter',
      reviewTest: 'Please review the test that you just completed',
      reviewVideo: 'Please rate the video you watched',
      tellUsMoreDetails: 'Tell us more details',
      thisWillHelpUpToImprove: 'this will help us to improve',
      whatDidYouLike: 'Tell us what exactly you liked',
      whatYouDidntLike: "Tell us what you didn't like?",
    },
    save: 'Save',
    school: 'School',
    schools: 'Schools',
    search: 'Search',
    searchHelpText: 'Try changing your search',
    seeDetails: 'Go to',
    selfWorkIsDone: 'Independent work completed',
    show: 'Show',
    solution: 'Solution',
    solvedCount: 'Done',
    sortByColumnAsc: 'sortByColumnAsc',
    sortByColumnDesc: 'sortByColumnDesc',
    sortedByColumnAsc: 'sortedByColumnAsc',
    sortedByColumnDesc: 'sortedByColumnDesc',
    startAt: 'Start at',
    startDate: 'Starting date',
    status: 'Status',
    statuses: {
      ACTIVE: 'Active',
      ALL: 'All',
      AVAILABLE: 'Available',
      DELETED: 'Deleted',
      DISABLED: 'Blocked',
      DRAFT: 'Draft',
      FAILED: 'Incorrect',
      FINISHED: 'Completed',
      GIVEN: 'Issued',
      INACTIVE: 'Inactive',
      INVITED: 'Invited',
      ISSUED: 'Issued',
      NA: 'Not achieved',
      NEW: 'New',
      NOT_AVAILABLE: 'Not available',
      NOT_INVITED: 'Uninvited',
      NOT_ISSUED: 'Not issued',
      NOT_PASSED: 'Not passed',
      PASSED: 'Passed',
      PAUSED: 'Paused',
      SOLVED: 'Resolved',
    },
    student: 'Student',
    studentDetails: 'Student details',
    studentProfile: 'Student profile',
    student_few: 'Student',
    student_many: 'Students',
    student_other: 'Students',
    students: 'Students',
    studio: 'Studio',
    studiosPage: {
      alertEndLesson: 'Are you sure you want to finish the lesson?',
      attemptsLeft: 'Attempts left',
      available: 'Available',
      chooseAnswer: 'Choose answer',
      chooseClass: 'Choose class',
      chooseGroup: 'Choose group',
      demonstrationsStudio: 'Demonstrations studio',
      endLesson: 'Complete the lesson',
      findTheBestMoveFor: 'Find the best move for',
      findTheBestMoveForBlack: 'Find the best move for Black',
      findTheBestMoveForWhite: 'Find the best move for White',
      giveHomeWork: 'Give homework',
      given: 'Given',
      hideAnswer: 'Hide answer',
      hideSolution: 'Hide solution',
      showAnswer: 'Show answer',
      showSolution: 'Show solution',
      studioView: 'Classroom Studio Demonstration',
      viewMoves: 'View moves',
      weWillSuggest: 'We will suggest you a suitable topic and exercises',
      yourMove: 'Your move',
    },
    successPasswordResetMessage: 'Password reset successfully',
    superCoach: 'Сoordinator',
    superCoaches: 'Сoordinators',
    teacher: 'Teacher',
    teachers: 'Teachers',
    test: 'Test',
    tests: 'Tests',
    time: 'Time',
    title: 'Title',
    total: 'Total',
    tryAgainLater: 'Try again later',
    type: 'Type',
    understand: 'Ok',
    videofiles: 'Video files',
    videolesson: 'Video lesson',
    yes: 'Yes',
    youHaveMoreAttempts: 'You have attempts left you can come back and improve your score',
    yourResult: 'Your result',
  },
};
